import { render, staticRenderFns } from "./Question_B.vue?vue&type=template&id=53925cae&scoped=true&"
import script from "./Question_B.vue?vue&type=script&lang=js&"
export * from "./Question_B.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53925cae",
  null
  
)

export default component.exports